import { GridState } from 'ag-grid-enterprise';

export interface IUserPreferences {
  favouritePagesUrl?: string[];
  isNavigationPinned?: boolean;
  conversationGridViews?: IGridView[];
  scorecardConversationsGridViews?: IGridView[];
  residentCallReasonsViews?: IGridView[];
  scorecardQuestionsViews?: IGridView[];
  agentActionsViews?: IGridView[];
  siteRankingViews?: IGridView[];
  agentRankingViews?: IGridView[];
  scorecardChallengesViews?: IGridView[];
}

export class UserPreferencesModel implements IUserPreferences {
  favouritePagesUrl: string[] = [];
  isNavigationPinned: boolean = false;
  conversationGridViews: IGridView[] = [];
  scorecardConversationsGridViews: IGridView[] = [];
  residentCallReasonsViews: IGridView[] = [];
  scorecardQuestionsViews: IGridView[] = [];
  agentActionsViews: IGridView[] = [];
  siteRankingViews: IGridView[] = [];
  agentRankingViews: IGridView[] = [];
  scorecardChallengesViews: IGridView[] = [];

  constructor(data?: IUserPreferences) {
    this.favouritePagesUrl = data?.favouritePagesUrl ?? this.favouritePagesUrl;
    this.isNavigationPinned = data?.isNavigationPinned ?? this.isNavigationPinned;
    this.conversationGridViews = data?.conversationGridViews ?? this.conversationGridViews;
    this.residentCallReasonsViews = data?.residentCallReasonsViews ?? this.residentCallReasonsViews;
    this.scorecardQuestionsViews = data?.scorecardQuestionsViews ?? this.scorecardQuestionsViews;
    this.agentActionsViews = data?.agentActionsViews ?? this.agentActionsViews;
    this.siteRankingViews = data?.siteRankingViews ?? this.siteRankingViews;
    this.agentRankingViews = data?.agentRankingViews ?? this.agentRankingViews;
    this.scorecardChallengesViews = data?.scorecardChallengesViews ?? this.scorecardChallengesViews;
    this.scorecardConversationsGridViews =
      data?.scorecardConversationsGridViews ?? this.scorecardConversationsGridViews;
  }
}

export type TViewsKeys = keyof Pick<
  IUserPreferences,
  | 'conversationGridViews'
  | 'scorecardConversationsGridViews'
  | 'residentCallReasonsViews'
  | 'scorecardQuestionsViews'
  | 'agentActionsViews'
  | 'siteRankingViews'
  | 'agentRankingViews'
  | 'scorecardChallengesViews'
>;

export interface IGridView {
  label: string;
  gridState: Partial<GridState>;
}
